import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function WarmGlowFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.WARM_GLOW}
      label="Warm"
      image="warm"
      thumbnailClassName="bg-gradient-to-br from-amber-100 via-amber-300 to-rose-300"
      showRecommended
    />
  );
}
